import {
    QUOTATIONS_FORM_UPDATE_FIELD,
    STORE_RESET
} from '../../actions/action-types';
import appInitialState from '../../store/appInitialState';

const initialState = appInitialState.quotationsForm;

/**
 * This is the application state's quotationsForm slice reducer
 *
 * @param {Object} state 
 * @param {Object} action
 * 
 * @usages
 *  ...
 */
function quotationsFormReducer(state = initialState, action) {

    switch(true) {

        case (action.type === STORE_RESET):
            
            state = {
                ...state,
                ...initialState
            };
            break;

        case (action.type === QUOTATIONS_FORM_UPDATE_FIELD):

            state = {
                ...state,
                ...action.payload
            };
            break;

        default:
            
    }

    return state;
};

export default quotationsFormReducer;